// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__UXLuq","header":"MergedInvoice_header__20dJb"};